import MuiGlobalStyles from '@mui/material/GlobalStyles';
import { fontFamily } from 'context/agentTheme';

const globalStyles = theme => ({
  'html, body, #root, #app': {
    height: '100%',
  },
  'html *': {
    boxSizing: 'border-box',
  },
  ':root': {
    '--primary-color': theme.palette.primary.main,
    '--secondary-color': theme.palette.secondary.main,
    '--error-color': theme.palette.error.main,
  },
  '.header': {
    fontSize: 16,
    fontFamily,
    fontWeight: 500,
  },
  '.title-text': {
    textTransform: 'uppercase',
  },
  '.hoverable': {
    transition: theme.transitions.create(['color']),
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  '.hover-color': {
    transition: theme.transitions.create(['color']),
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  '.link': {
    fontSize: 14,
    lineHeight: 1.3,
    textDecorationLine: 'underline',
    textTransform: 'uppercase',
    color: '#000000',
  },
  '.linkHidden': {
    fontSize: 14,
    lineHeight: 1,
    textDecorationLine: 'none',
    color: '#000000',
  },
  '.linkDisabled': {
    cursor: 'not-allowed !important',
    pointerEvents: 'unset !important',
    '&:hover': {
      backgroundColor: 'unset !important',
    },
  },
  '.linkOff': {
    pointerEvents: 'none',
  },
  '.line-clamp-1': {
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  '.line-clamp-2': {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  '.line-clamp-3': {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  '.error': {
    color: theme.palette.error.main,
  },
  '.react-datepicker.itinerary-builder-calendar': {
    borderRadius: 0,
    border: 0,
    padding: 20,
    '& .react-datepicker__month-container': {
      float: 'unset',
    },
    '& .react-datepicker__header': {
      padding: 0,
      backgroundColor: '#fff',
      borderBottom: '1px solid #C6C6C5',
    },
    '& .react-datepicker__week': {
      marginBottom: 5,
    },
    '& .react-datepicker__day-names, & .react-datepicker__week': {
      display: 'flex',
      gap: 5,
    },
    '& .react-datepicker__day-name': {
      color: '#C6C6C5',
    },
    '& .react-datepicker__day': {
      borderRadius: '50%',
      position: 'relative',
    },
    '& .react-datepicker__day--outside-month:not(.is-own-date)': {
      opacity: 0.3,
    },
    '& .react-datepicker__day-name, & .react-datepicker__day': {
      width: 'calc(100% / 7)',
      aspectRatio: 1,
      display: 'flex',
      margin: 0,
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& .btn': {
      color: '#221F20',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      '& svg': {
        width: 9,
        height: 'auto',
      },
    },
    '& .MuiInputBase-root': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .MuiSelect-root': {
      minHeight: 'auto',
      padding: 10,
      fontSize: 12,
      lineHeight: 1,
    },
    '& .MuiSelect-icon': {
      position: 'relative',
      top: 'auto',
      right: 'auto',
      marginRight: 7,
    },
  },
});

const GlobalStyles = () => <MuiGlobalStyles styles={globalStyles} />;

export default GlobalStyles;
